/* Svensk katalog for locale-invoice-list-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'inv.title': 'Fakturalista',
  'inv.titleHelp': 'Översikt över fakturor, offerter, orderbekräftelser och kreditfakturor för valt räkenskapsår.',
  'inv.searchPh': 'Sök på fakturanummer, kund eller belopp',
  'inv.searchHelp': 'Sök i listan på fakturanummer, kundnamn, fakturabelopp, nettobelopp, betalt belopp eller restbelopp.',
  'inv.downloadHelp': 'Ladda ned listan för fliken och filtret du har valt.',
  'inv.addHelp': 'Skapa en ny faktura.',
  'inv.add': 'Ny faktura',
  'inv.filterHelp': 'Filtrera listan på status, dokumenttyp, datum, period, belopp och arkiv.',
  'inv.tabsHelpTitle': 'Dokumenttyper',
  'inv.tabsHelp': 'Växla mellan Faktura, Utkast, Offert/Orderbekräftelse, Kreditfaktura och Försäljningsrapport.',
  'inv.listHelpTitle': 'Fakturalistan',
  'inv.listHelp': 'Varje rad är ett dokument från backend. Tryck på en rad för detaljer och åtgärder.',
  'inv.loading': 'Läser in fakturor',
  'inv.loadingSub': 'Hämtar data från backend.',
  'inv.noMatch': 'Inga träffar här',
  'inv.noMatchSub': 'Prova en annan flik eller återställ filtret.',
  'inv.backToVouchers': 'Tillbaka till transaktioner',
  'inv.type.invoice': 'Faktura',
  'inv.type.quote': 'Offert',
  'inv.type.orderConfirmation': 'Orderbekräftelse',
  'inv.type.creditNote': 'Kreditfaktura',
  'inv.type.unknown': 'Dokument',
  'inv.tab.salesReport': 'Försäljningsrapport',
  'inv.importHistory.tab': 'Importerad historik',
  'inv.importHistory.loading': 'Hämtar importerad fakturahistorik …',
  'inv.importHistory.error': 'Det gick inte att hämta importerad fakturahistorik.',
  'inv.importHistory.readOnly': 'Det här är skrivskyddad historik från det tidigare systemet. Posterna påverkar inte bokföring eller moms och har inga fakturaåtgärder i Plumme.',
  'inv.importHistory.documents': 'Dokument',
  'inv.importHistory.year': 'Importerad historik för {year}',
  'inv.importHistory.netSales': 'Nettoförsäljning',
  'inv.importHistory.customers': 'Kunder',
  'inv.importHistory.creditNotes': 'Kreditfakturor',
  'inv.importHistory.netIncluded': 'Avdraget från nettoförsäljning',
  'inv.importHistory.search': 'Sök på fakturanummer eller kund',
  'inv.importHistory.empty': 'Inga importerade fakturadetaljer för det här året',
  'inv.importHistory.emptySub': 'Importerade bokföringssiffror används fortfarande i rapporter och råd när de finns.',
  'inv.importHistory.detailTitle': 'Detaljer från importfilen',
  'inv.importHistory.dueDate': 'Förfallodatum',
  'inv.importHistory.paidDate': 'Reglerad den',
  'inv.importHistory.remaining': 'Utestående',
  'inv.importHistory.lines': 'Importerade rader',
  'inv.importHistory.noLines': 'Källsystemet levererade bara fakturatotaler för det här dokumentet.',
  'inv.importHistory.markSettled': 'Markera som reglerad',
  'inv.importHistory.reopenStatus': 'Öppna status igen',
  'inv.importHistory.manualSettledNote': 'Markerad som reglerad i Plumme utan bokföring.',
  'inv.importHistory.settledToast': 'Den importerade fakturan är markerad som reglerad.',
  'inv.importHistory.reopenedToast': 'Den importerade fakturan har öppnats igen.',
  'inv.importHistory.statusError': 'Det gick inte att uppdatera den importerade fakturan.',
  'inv.importHistory.sourceNote': 'Importerad från tidigare system – dokumentet finns i importfilen.',
  'inv.importHistory.creditReference': 'Importerad kreditfaktura från tidigare system – krediterar faktura {number}.',
  'inv.importHistory.creditedReference': 'Importerad från tidigare system · krediterad med kreditfaktura {number}',
  'inv.importHistory.reanalysisTitle': 'Importerad fakturahistorik måste analyseras på nytt',
  'inv.importHistory.reanalysisBody': 'Den sparade analysen är från innan kreditfakturor hämtades från egna kreditfakturablad. Källdata ändras inte.',
  'inv.importHistory.reanalysisAction': 'Gå till omanalys',
  'inv.importHistory.rowSource': 'Importerad från tidigare system',
  'adv.sales.importedHistoryNote': 'Analysen kombinerar bokförda Plumme-fakturor med skrivskyddad försäljningshistorik från importen. Kreditfakturor är avdragna. {coverage}',
  'adv.sales.importedTotalsCoverage': 'Importen innehåller fakturatotaler men inte produktrader för alla dokument.',
  'adv.sales.importedLinesCoverage': 'Importen innehåller även fakturarader för delar av historiken.',
  'inv.tab.drafts': 'Utkast',
  'inv.filterDocType': 'Dokumenttyp',
  'inv.filterArchive': 'Arkiv',
  'inv.filterSeeArchived': 'Visa arkiverade',
  'inv.status.draft': 'Utkast',
  'inv.status.created': 'Inte skickad',
  'inv.status.sent': 'Skickad',
  'inv.status.accepted': 'Accepterad',
  'inv.status.confirmed': 'Bekräftad',
  'inv.status.paid': 'Betald',
  'inv.status.unpaid': 'Obetald',
  'inv.status.overdue': 'Förfallen',
  'inv.status.credited': 'Krediterad',
  'inv.kpi.invoiceCount': 'Fakturor',
  'inv.kpi.invoiceCount.help': 'Antal fakturor du har skapat under det valda året, oavsett status.',
  'inv.kpi.revenue': 'Omsättning',
  'inv.kpi.revenue.help': 'Summan av alla fakturor exklusive moms under året.',
  'inv.kpi.notSent': 'Inte skickade',
  'inv.kpi.notSent.help': 'Fakturor som ligger som utkast och väntar på att skickas.',
  'inv.kpi.credited': 'Krediterade',
  'inv.kpi.credited.help': 'Antal kreditfakturor.',
  'inv.kpi.quotes': 'Offerter',
  'inv.kpi.quotes.help': 'Antal offerter under året.',
  'inv.kpi.accepted': 'Accepterade',
  'inv.kpi.accepted.help': 'Antal offerter som kunden har accepterat.',
  'inv.kpi.orders': 'Orderbekräftelser',
  'inv.kpi.orders.help': 'Antal orderbekräftelser under året.',
  'inv.kpi.creditNotes': 'Kreditfakturor',
  'inv.kpi.creditNotes.help': 'Antal kreditfakturor under året.',
  'inv.kpi.value': 'Värde',
  'inv.kpi.value.help': 'Sammanlagt värde exklusive moms för dokumenten i den här fliken.',
  'inv.kpi.amount': 'Belopp',
  'inv.kpi.amount.help': 'Sammanlagt belopp exklusive moms för kreditfakturorna.',
  'inv.kpi.sent': 'Skickade',
  'inv.kpi.sent.help': 'Antal dokument som har skickats till kunden.',
  'inv.kpi.confirmed': 'Bekräftade',
  'inv.kpi.confirmed.help': 'Orderbekräftelser som kunden har bekräftat.',
  'inv.kpi.drafts': 'Utkast',
  'inv.kpi.drafts.help': 'Dokument som ännu inte har skickats.',
  'inv.kpi.potentialRevenue': 'Möjlig omsättning',
  'inv.kpi.potentialRevenue.help': 'Sammanlagt värde av utkast som kan skickas.',
  'inv.kpi.customers': 'Kunder',
  'inv.kpi.customers.help': 'Antal unika kunder på utkasten.',
  'inv.kpi.history': 'Historik',
  'inv.kpi.history.help': 'Hur länge det äldsta utkastet har väntat.',
  'inv.kpi.sub.totalYear': 'Totalt i år',
  'inv.kpi.sub.exVat': 'Exkl. moms',
  'inv.kpi.sub.waiting': 'Väntar på dig',
  'inv.kpi.sub.creditNotes': 'Kreditfakturor',
  'inv.kpi.sub.started': 'Påbörjade dokument',
  'inv.kpi.sub.uniqueCustomers': 'Unika kunder',
  'inv.kpi.sub.oldestDraft': 'Äldsta utkast',
  'inv.kpi.sub.noDrafts': 'Inga utkast',
  'inv.kpi.sub.none': 'Inga',
  'inv.kpi.sub.days': '{n} dagar',
  'inv.kpi.sub.sentQuotes': 'Skickade offerter',
  'inv.kpi.sub.accepted': 'Accepterade',
  'inv.kpi.sub.confirmed': 'Bekräftade',
  'inv.kpi.sub.notSent': 'Inte skickade',
  'inv.kpi.sub.sent': 'Skickade',
  'inv.col.document': 'Dokument',
  'inv.col.invoice': 'Faktura',
  'inv.col.date': 'Datum',
  'inv.col.net': 'Netto',
  'inv.col.amount': 'Belopp',
  'inv.col.status': 'Status',
  'inv.col.number': 'Nr',
  'inv.col.customer': 'Kund',
  'inv.netInline': 'Netto {amount}',
  'inv.draftPlaceholder': 'UTKAST',
  'inv.detail.dueTitle': 'Förfallodag',
  'inv.detail.dueHelp': 'Datumet som dokumentet gäller till eller ska vara betalt senast.',
  'inv.detail.statusHelp': 'Betalningar hämtas från bokförda PaymentEntry-poster. Offerter och orderbekräftelser visar genomförandestatus.',
});
